import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListEmspUserLastNameCell } from './emsp-bo-charging-session-list-emsp-user-last-name.cell';
import { EmspBoChargingSessionListEmspUserLastNameHeader } from './emsp-bo-charging-session-list-emsp-user-last-name.header';

export const EmspBoChargingSessionListEmspUserLastNameColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['emspUser']['lastName']
> = {
  id: 'emspUserLastName',
  enableSorting: false,
  header: EmspBoChargingSessionListEmspUserLastNameHeader,
  cell: EmspBoChargingSessionListEmspUserLastNameCell,
};
